import { cloneElement } from "react";
import "./Head.css";
import {
  AppBar,
  Toolbar,
  Button,
  useScrollTrigger,
  Typography,
  Divider,
  Link,
} from "@mui/material";

import logo from "../../assetes/logo.png";

import ButtonEnglish from "./English/Button English";

const Header = () => {
  function ElevationScroll(props) {
    const { children } = props;
    const trigger = useScrollTrigger({
      disableHysteresis: true,
      threshold: 0,
    });

    return cloneElement(children, {
      elevation: trigger ? 4 : 0,
    });
  }
  return (
    <>
      <ElevationScroll>
        <AppBar className="app-bar" color="grey">
          <Toolbar>
            <img className="logo-head" src={logo} alt="IMA"></img>
            <Typography
              className="text-logo"
              variant="h1"
              sx={{
                fontFamily: "Homa",
                color: "#49519A",
              }}
            >
              گروه صنعتی ایما
            </Typography>
            <Divider orientation="vertical" variant="middle" flexItem />
            <Link href="#" underline="none" color="white" sx={{ margin: 1 }}>
              <Typography variant="body2" className="typo-head">
                صفحه نخست
              </Typography>
            </Link>
            <Link
              href="#about"
              underline="none"
              color="white"
              sx={{ margin: 1 }}
            >
              <Typography variant="body2" className="typo-head">
                درباره ما
              </Typography>
            </Link>

            <Link
              href="#projects"
              underline="none"
              color="white"
              sx={{ margin: 1 }}
            >
              <Typography variant="body2" className="typo-head">
                پروژه ها
              </Typography>
            </Link>
            <Link
              href="#contact"
              underline="none"
              color="white"
              sx={{ margin: 1 }}
            >
              <Typography variant="body2" className="typo-head">
                ارتباط با ما
              </Typography>
            </Link>
            <Button className="button-digima" variant="contained" color="blue">
              <a
                className="typo-head"
                href="https://digimakala.com/"
                target="_blank"
                // style={{ fontSize: "1.1rem" }}
              >
                فروشگاه آنلاین
              </a>
            </Button>

            <div>
              <ButtonEnglish />
            </div>
          </Toolbar>
        </AppBar>
      </ElevationScroll>
    </>
  );
};

export default Header;
